<template>
  <ApolloMutation
    ref="purchaseStoryMutation"
    :mutation="
      (gql) => gql`
      mutation PurchaseStory($storyId: String!) {
        createStoryPurchase(input: {storyId: $storyId}) {
          storyPurchase {
            id
            paidAt
            temporaryCheckoutUrl
            owner {
              id
              userProfile {
                username
              }
            }
            createdAt
            updatedAt
            story {
              id
              name
              priceCents
            }
          }
        }
      }
    `
    "
    :variables="{ storyId: idWithIri }"
    @done="handlePurchase"
    :update="updateCache"
  >
    <template v-slot="{ mutate, loading, error }">
      <v-row>
        <v-col>
          <v-btn color="primary" @click="mutate" :loading="loading" :disabled="loading"
            >
            {{ $t('store.buyNow') }}
            </v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="forwarding">
        <v-col>
          <v-alert type="info">{{ $t('becomeACreator.houseKeeping.forwardingYouToStripe') }}</v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-alert class="my-5" type="error" v-if="error">{{ error }}</v-alert>
        </v-col>
      </v-row>
    </template>
  </ApolloMutation>
</template>
<script>
import gql from 'graphql-tag'
export default {
  props: {
    idWithIri: String,
    parentLoading: Boolean,
    activate: Boolean,
  },
  data() {
    return {
      forwarding: false,
    };
  },
  mounted() {
    if (this.activate) {
      this.$router.replace({'query': null});
      this.$refs.purchaseStoryMutation.mutate();
    }
  },
  watch: {
    activate(newValue) {
      if (newValue) {
        this.$router.replace({'query': null});
        this.$refs.purchaseStoryMutation.mutate();
      }
    },
  },
  methods: {
    handlePurchase(result) {
      this.forwarding = true;
      window.location.href = result.data.createStoryPurchase.storyPurchase.temporaryCheckoutUrl;
    },
    updateCache(store, { data: { createStoryPurchase } }) {
      const query = {
        query: gql`
        query {
          getLoggedInUser {
            id
            storyPurchases(exists: {paidAt: true}) {
              id
              paidAt
              story {
                id
              }
            }
          }
        }
        `,
      }
      // Read the query from cache
      const data = store.readQuery(query)
      // Mutate cache result
      const newData = data.getLoggedInUser.storyPurchases.edges.concat({
        node: createStoryPurchase.storyPurchase,
      })

      // Write back to the cache
      store.writeQuery({
        ...query,
        data: {
          getLoggedInUser: {
            id: data.getLoggedInUser.id,
            storyPurchases: {
              edges: newData,
            },
          }
        }
      })
    },
  },
};
</script>
